module.exports = __webpack_public_path__ + "img/song.eeeef4dd.png";